import { Component, OnInit,Inject,Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { Afiliado } from '../../models/afiliado/afiliado.model';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';
import { EscolaridadService } from '../../services/escolaridad/escolaridad.service';
import { ProductosService } from 'src/app/services/productos/productos.service';
import { AfiliacionService } from 'src/app/services/afiliacion/afiliacion.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { DialogObservacionHistoricoComponent } from 'src/app/components/solicitud-afiliacion/dialog-observacion-historico.component';
import { MantenedorUsuariosService } from 'src/app/services/mantenedor-usuarios/mantenedor-usuarios.service';

import { Usuario } from '../../models/usuario/usuario.model';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import Swal from 'sweetalert2';

declare const Rut: any;
declare const ageCalculator: any;

@Component({
  selector: 'app-afiliacion-tab8',
  templateUrl: '../../pages/afiliacion/afiliacion.tab8.html',
  styleUrls: ['../../pages/mantenedor-convenio-colaboracion/mantenedor-convenio-colaboracion.component.css']
})
export class AfiliacionTab8Component implements OnInit {

    rol:string = localStorage.getItem("rol")
    nombreUsuario: string = localStorage.getItem("nombreUsuario")
    @Input() afiliado: Afiliado;
    idEjecutivo = localStorage.getItem("idUsuario")
    bancos: any;
    cursos: any[]; postulantes: any[];
    sistemaSalud: any


    constructor(private router:Router, private escolaridadService:EscolaridadService,
                private afiliacionService:AfiliacionService, private dialog: MatDialog,
                private mantenedorService: MantenedorUsuariosService) { }

    ngOnInit(): void
    {   
        let vm = this

    }

    guardar()
    {        
      var vm = this
   
      Swal.fire({
        allowOutsideClick:false,
        icon:'info',
        text:'Cargando...'
      });
      Swal.showLoading();
       
        this.afiliacionService.guardar(vm.afiliado.id,vm.afiliado.observacion,vm.idEjecutivo).then
        (
            response =>
            {
                console.log(response)
                vm.openAlertDialog('Se han guardado correctamente los datos del afiliado.', 'btn-success')
                Swal.close();              
            }
        )
        .catch
        (
            (err) =>
            {
                console.log(err)
                vm.openAlertDialog('Se ha generado un error al guardar los datos.', 'btn-success')
                Swal.close(); 
            }
        )
    }


    historicosObservaciones()
    {  
        var vm = this
        let dataRechazo: any =
        {       
            rut: vm.afiliado.rut,
            nombreCompleto: '',
        }
        let data: any = {}
          const dialogRef = this.dialog.open(DialogObservacionHistoricoComponent, { 
            data: dataRechazo,  disableClose: true, panelClass: 'dialog-content-scrollable', width: '45%' })
          dialogRef.afterClosed().subscribe(() => {
        
              Swal.close();       
             
          })
    
    }


    openAlertDialog(mensaje: string, clase: string)
    {
        this.dialog.open(AlertDialogComponent, {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }

    salir()
    {
        const dialogRef = this.dialog.open(ConfirmationDialog, {
            data: { message: '¿Esta seguro de salir del formulario?', buttonText: { ok: 'Si', cancel: 'No' }  }
        });

        dialogRef.afterClosed().subscribe((confirmed: boolean) =>
        {
            if (confirmed) { this.router.navigate(['/index']); }
        });
    }
}
